import type { Reducer } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { VAUTO_APPRAISALS_FAILURE, VAUTO_APPRAISALS_REQUEST, VAUTO_APPRAISALS_SUCCESS } from '../actionTypes/vAutoActionTypes';
import type { VAutoState } from '@makemydeal/dr-dash-types';

export const vAutoInitialState: VAutoState = {
    items: [],
    hasError: false
};

export type vAutoReducer = Reducer<VAutoState>;

/** Counts only fetches flagged `meta.isRefresh`, so the fetch on deal load shows no ACV indicator. */
const adjustPendingRefreshCount = (state: VAutoState, action: AnyFSA, delta: number): number => {
    const current = state.pendingRefreshCount || 0;
    if (!action.meta?.isRefresh) {
        return current;
    }
    return Math.max(current + delta, 0);
};

export const reducer: vAutoReducer = (state: VAutoState = vAutoInitialState, action: AnyFSA) => {
    switch (action.type) {
        case VAUTO_APPRAISALS_REQUEST: {
            return { ...state, hasError: false, pendingRefreshCount: adjustPendingRefreshCount(state, action, 1) };
        }
        case VAUTO_APPRAISALS_SUCCESS: {
            // An empty 200/204 leaves `payload` undefined, which used to throw here and abort the
            // dispatch. Treat an absent body as "no new information" and keep the current items; an
            // empty `items` array does mean "no appraisals" and clears them.
            const items = action.payload?.data?.items;
            return {
                ...state,
                items: Array.isArray(items) ? items : state.items,
                pendingRefreshCount: adjustPendingRefreshCount(state, action, -1)
            };
        }
        case VAUTO_APPRAISALS_FAILURE: {
            return { ...state, hasError: true, pendingRefreshCount: adjustPendingRefreshCount(state, action, -1) };
        }

        default: {
            return state;
        }
    }
};
